import { render } from "./floader.vue?vue&type=template&id=f9ff92e6"
import script from "./floader.vue?vue&type=script&lang=js"
export * from "./floader.vue?vue&type=script&lang=js"

import "./floader.vue?vue&type=style&index=0&id=f9ff92e6&lang=css"

import exportComponent from "D:\\work\\sckj\\wwei\\ww-vue\\wwei_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__